var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExit1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Exit_1_",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.402,
    height: 28,
    viewBox: "0 0 18.402 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M42.892,25.83l-2.219-2.218a.429.429,0,0,0-.607.607l1.472,1.472H35.267v.888h6.271l-1.471,1.472a.429.429,0,1,0,.607.607l2.219-2.219a.429.429,0,0,0,0-.607Z",
    transform: "translate(-24.616 -13.264)",
    fill: "#0b8275"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M24.136,17.76a.444.444,0,0,0-.444.444v4.788a.967.967,0,0,1-.862.981H20.142V4.631l-.554-.237-7.075-3L12.4,1.34H22.83a.856.856,0,0,1,.862.866V8.884a.444.444,0,1,0,.888,0V2.206A1.754,1.754,0,0,0,22.83.452H11.71a.44.44,0,0,0-.436.4l-.008,0v23.82l7.626,3.242,1.249.536V24.86H22.83a1.841,1.841,0,0,0,1.75-1.868V18.2A.444.444,0,0,0,24.136,17.76ZM19.255,5.239V27.079l-7.1-3.007V2.228l7.1,3.006,0,0Z",
    transform: "translate(-11.267 -0.452)",
    fill: "#0b8275"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit1);
export default __webpack_public_path__ + "static/media/exit-1.377340c7b76ff162106981bfd8f12e49.svg";
export { ForwardRef as ReactComponent };